import { render, staticRenderFns } from "./schoolArea.vue?vue&type=template&id=277c32ec&scoped=true"
import script from "./schoolArea.vue?vue&type=script&lang=js"
export * from "./schoolArea.vue?vue&type=script&lang=js"
import style0 from "./schoolArea.vue?vue&type=style&index=0&id=277c32ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c32ec",
  null
  
)

export default component.exports